import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQuery";
import type {
  ReclassifyRequest,
  ReclassifyResponse,
  SurveySentimentSnapshot,
} from "@/types/sentiment";

export const sentimentApi = createApi({
  reducerPath: "sentimentApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Sentiment"],
  endpoints: (builder) => ({
    getSurveySentiment: builder.query<SurveySentimentSnapshot, number>({
      query: (threadId) => `api/sentiment/threads/${threadId}/survey`,
      providesTags: (_r, _e, threadId) => [{ type: "Sentiment", id: threadId }],
    }),
    postReclassifySurvey: builder.mutation<
      ReclassifyResponse,
      { threadId: number } & ReclassifyRequest
    >({
      query: ({ threadId, ...body }) => ({
        url: `api/sentiment/threads/${threadId}/survey/reclassify`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_r, _e, { threadId }) => [{ type: "Sentiment", id: threadId }],
    }),
    getSentimentRuns: builder.query<{ runs: unknown[] }, number>({
      query: (threadId) => `api/sentiment/threads/${threadId}/survey/runs`,
    }),
    getSentimentHealth: builder.query<
      {
        status: "ok" | "degraded" | "down";
        pendingCount: number;
        failedLast24h: number;
        lastSuccessfulRunAt: string | null;
      },
      void
    >({
      query: () => "api/sentiment/health",
    }),
  }),
});

export const {
  useGetSurveySentimentQuery,
  usePostReclassifySurveyMutation,
  useGetSentimentRunsQuery,
  useGetSentimentHealthQuery,
} = sentimentApi;
